import type { IconSvgObject } from './types';

const CalendarPlusIcon: IconSvgObject = [
  ["path", { d: "M16 2V6M7 2V6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20.5 13V6C20.5 4.89543 19.6046 4 18.5 4H4.5C3.39543 4 2.5 4.89543 2.5 6V20C2.5 21.1046 3.39543 22 4.5 22H13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2.5 10H20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M15.5 18.995H21.5M18.495 22L18.495 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default CalendarPlusIcon;
